import React from "react";
import { colors } from "../../../design-system";
import { formatCurrency } from "../helpers";
import { itemTd } from "../styles";

interface DeductionRowProps {
  label: string;
  current: number | string | null | undefined;
  ytd?: number | string | null;
  bold?: boolean;
  currency?: string;
}

export default function DeductionRow({
  label,
  current,
  ytd,
  bold,
  currency,
}: DeductionRowProps) {
  return (
    <tr style={{ borderBottom: "1px solid " + colors.borderSubtle }}>
      <td
        style={itemTd({
          color: bold ? colors.textPrimary : colors.textSecondary,
          fontWeight: bold ? 600 : 400,
        })}
      >
        {label}
      </td>
      <td
        style={itemTd({
          textAlign: "right",
          color: colors.textPrimary,
          fontWeight: bold ? 700 : 500,
        })}
      >
        {formatCurrency(current, currency)}
      </td>
      <td style={itemTd({ textAlign: "right", color: colors.textMuted })}>
        {ytd !== undefined && ytd !== null
          ? formatCurrency(ytd, currency)
          : ""}
      </td>
    </tr>
  );
}